import React, { Component } from "react";

import DonationSelector from "components/DonationSelector/DonationSelector";
import CampaignReceives from "./donationCalculator/campaignReceives";
import DonorTotal from "./donationCalculator/donorTotal";
import OptionalDonation from "./donationCalculator/optionalDonation";
import PaymentProcessingFee from "./donationCalculator/paymentProcessingFee";

const fees = [
  { feeTier: (a) => a > 0 && a <= 5, tiers: [1, 2, 3, 4] },
  { feeTier: (a) => a > 5 && a < 25, tiers: [1, 2, 3, 5] },
  { feeTier: (a) => a === 25, tiers: [1, 3, 4, 5] },
  { feeTier: (a) => a > 25 && a < 50, tiers: [1, 3, 4, 5] },
  { feeTier: (a) => a === 50, tiers: [4, 5, 6, 8] },
  { feeTier: (a) => a > 50 && a < 100, tiers: [6, 7, 8, 15] },
  { feeTier: (a) => a === 100, tiers: [6, 8, 10, 15] },
  { feeTier: (a) => a > 100 && a < 500, tiers: [10, 12, 15, 35] },
  { feeTier: (a) => a === 500, tiers: [25, 30, 35, 65] },
  { feeTier: (a) => a > 500 && a < 1000, tiers: [25, 30, 35, 65] },
  { feeTier: (a) => a === 1000, tiers: [35, 45, 55, 65] },
  { feeTier: (a) => a > 1000, tiers: [70, 75, 85, 105] },
  { feeTier: (a) => a > 0 && a <= 5, tiers: [85, 105, 115, 125] },
];

export const calculateOptionalAmount = (donationAmount, tier) => {
  if (tier === 4 || donationAmount <= 0) {
    return "0.00";
  }

  const amount = Number.parseFloat(donationAmount);
  const feeTier = fees
    .filter((fee) => fee.feeTier(amount))
    .map(({ tiers }) => tiers[tier]);

  const optionalAmount = feeTier[0];

  return optionalAmount?.toFixed(2) || null;
};

class DonationCalculationForm extends Component {
  state = {
    paymentProcessingFee: 0,
    chuffedAmount: 0,
    donorAmountTotal: 0,
    chuffedDonorAmountTotal: 0,
    campaignAmountTotal: 0,
    donationSelectedAmount: 0,
    feeAmount: 0,
    selectedTier: 1,
    chuffedAmountDisabled: true,
    resetSelected: false,
    selectedIndex: 0,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.paymentModel !== this.props.paymentModel) {
      this.resetAmounts();
    }
  }

  resetAmounts = () => {
    this.setState({
      paymentProcessingFee: 0,
      chuffedAmount: 0,
      donorAmountTotal: 0,
      chuffedDonorAmountTotal: 0,
      campaignAmountTotal: 0,
      donationSelectedAmount: 0,
      feeAmount: 0,
      chuffedAmountDisabled: true,
      resetSelected: true,
    });
  };

  handleOptionalSelectUpdate = (event) => {
    const value = event.target.selectedOptions[0].innerHTML.split("$");
    const amount = Number.parseFloat(value[1]);
    const chosenAmount = this.state.donorAmountTotal;

    this.setState({
      chuffedDonorAmountTotal: (Number.parseFloat(chosenAmount) + amount).toFixed(2),
      selectedTier: event.target.value,
    });
  };

  handleAfterDonationUpdated = (amount) => {
    const {
      feeStructure,
      paymentModel,
    } = this.props;

    this.setState({
      donationSelectedAmount: amount,
      chuffedAmountDisabled: false,
    });

    const paymentModelSelected = paymentModel !== undefined ? paymentModel : "Keep 100";
    this.calculateProcessingFee(amount, paymentModelSelected, feeStructure[0]);
  };

  calculateProcessingFee = (amount, paymentModel, feeStructure) => {
    const donationValue = Number.parseFloat(amount, 10);

    if (!(donationValue > 0)) {
      return 0;
    }

    let fixedFee = Number.parseFloat(feeStructure.blended_fixed);
    let variableFee = Number.parseFloat(feeStructure.blended_variable);

    if (paymentModel === "Keep 100") {
      fixedFee = Number.parseFloat(feeStructure.domestic_fixed);
      variableFee = Number.parseFloat(feeStructure.domestic_variable);
    }

    // defaults - uses keep 100 model
    const donationWithFee = (donationValue + fixedFee) / (1 - variableFee);
    const feeComponent = donationWithFee - donationValue;
    let donorTotal = (donationValue + fixedFee) / (1 - variableFee);
    let campaignRecieves = donationValue;
    const chuffedAmount = (donationValue * 0.049).toFixed(2);
    const selectedDonation = Number.parseFloat(calculateOptionalAmount(amount, this.state.selectedTier));

    switch (paymentModel) {
      case "Keep 100":
        break;
      case "Shared":
        campaignRecieves = donationValue - feeComponent;
        donorTotal = donationValue;
        break;
      case "Flat Fee":
        campaignRecieves = (donationValue - feeComponent) - chuffedAmount;
        donorTotal = donationValue;
        break;
      default:
        break;
    }

    this.setState({
      paymentProcessingFee: feeComponent > 0 ? feeComponent.toFixed(2) : 0,
      donorAmountTotal: donorTotal.toFixed(2),
      campaignAmountTotal: campaignRecieves.toFixed(2),
      chuffedAmount: paymentModel === "Flat Fee" && chuffedAmount,
      chuffedDonorAmountTotal: (donorTotal + selectedDonation).toFixed(2),
      feeAmount: feeComponent,
      resetSelected: false,
    });
  };

  setSelectedIndex = (index) => {
    this.setState({
      selectedIndex: index,
    });
  };

  render() {
    const {
      feeStructure,
      paymentModel,
    } = this.props;

    const fixedFee = Number.parseFloat(feeStructure[0].blended_fixed);
    const variableFee = Number.parseFloat(feeStructure[0].blended_variable);
    const currencySymbol = feeStructure[0].currency_symbol;

    return (
      <div className="fees__donation-form--calculator">
        <p className="fees__donation-form--calculator-title">Calculate your donation</p>
        <div className="donation-form__body">
          <div className="donation-form__fieldset">
            <DonationSelector
              currencySymbol={currencySymbol}
              donationOptions={undefined}
              setSelectedIndex={this.setSelectedIndex}
              resetSelected={this.state.resetSelected}
              handleDonationAmountChange={this.handleAfterDonationUpdated}
              onChange={this.handleAfterDonationUpdated}
            />

            {
              paymentModel === "Keep 100" && (
                <div className="fees__donation-form--calculator-information">
                  <PaymentProcessingFee
                    variableFee={variableFee}
                    currencySymbol={currencySymbol}
                    fixedFee={fixedFee}
                    paymentProcessingFee={this.state.paymentProcessingFee}
                  />

                  <OptionalDonation
                    handleOptionalSelectUpdate={this.handleOptionalSelectUpdate}
                    selectedTier={this.state.selectedTier}
                    chuffedAmountDisabled={this.state.chuffedAmountDisabled}
                    currencySymbol={currencySymbol}
                    donationSelectedAmount={this.state.donationSelectedAmount}
                    calculateOptionalAmount={calculateOptionalAmount}
                  />

                  <DonorTotal
                    currencySymbol={currencySymbol}
                    chuffedDonorAmountTotal={this.state.chuffedDonorAmountTotal}
                    donorAmountTotal={this.state.donorAmountTotal}
                  />

                  <CampaignReceives
                    currencySymbol={currencySymbol}
                    campaignAmountTotal={this.state.campaignAmountTotal}
                  />
                </div>
              )
            }

            {
              paymentModel === "Shared" && (
                <div className="fees__donation-form--calculator-information">
                  <OptionalDonation
                    handleOptionalSelectUpdate={this.handleOptionalSelectUpdate}
                    selectedTier={this.state.selectedTier}
                    chuffedAmountDisabled={this.state.chuffedAmountDisabled}
                    currencySymbol={currencySymbol}
                    donationSelectedAmount={this.state.donationSelectedAmount}
                    calculateOptionalAmount={calculateOptionalAmount}
                  />

                  <DonorTotal
                    currencySymbol={currencySymbol}
                    chuffedDonorAmountTotal={this.state.chuffedDonorAmountTotal}
                    donorAmountTotal={this.state.donorAmountTotal}
                  />

                  <PaymentProcessingFee
                    variableFee={variableFee}
                    currencySymbol={currencySymbol}
                    fixedFee={fixedFee}
                    paymentProcessingFee={this.state.paymentProcessingFee}
                  />

                  <CampaignReceives
                    currencySymbol={currencySymbol}
                    campaignAmountTotal={this.state.campaignAmountTotal}
                  />
                </div>
              )
            }

            {
              paymentModel === "Flat Fee" && (
                <div className="fees__donation-form--calculator-information">
                  <DonorTotal
                    currencySymbol={currencySymbol}
                    chuffedDonorAmountTotal={null}
                    donorAmountTotal={this.state.donorAmountTotal}
                  />

                  <PaymentProcessingFee
                    variableFee={variableFee}
                    currencySymbol={currencySymbol}
                    fixedFee={fixedFee}
                    paymentProcessingFee={this.state.paymentProcessingFee}
                  />

                  <div>
                    <span className="fees__donation-form-fee">
                      <p>
                        Chuffed.org platform fee:
                        <span>(4.9%)</span>
                      </p>
                      <p className="fees__donation-form-amounts">
                        {currencySymbol}
                        {this.state.chuffedAmount > 0 ? this.state.chuffedAmount : 0}
                      </p>
                    </span>
                  </div>

                  <CampaignReceives
                    currencySymbol={currencySymbol}
                    campaignAmountTotal={this.state.campaignAmountTotal}
                  />
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

export default DonationCalculationForm;
